__turbopack_context__.v({
  "current-page": "HeaderNavigationMenu-module-scss-module__UpSVvG__current-page",
  "info-chip": "HeaderNavigationMenu-module-scss-module__UpSVvG__info-chip",
  "label-container": "HeaderNavigationMenu-module-scss-module__UpSVvG__label-container",
  "menu-desk": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu-desk",
  "menu-mobile": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu-mobile",
  "menu__a": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu__a",
  "menu__li": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu__li",
  "menu__text": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu__text",
  "menu__ul": "HeaderNavigationMenu-module-scss-module__UpSVvG__menu__ul",
  "mobile-nav-chevron": "HeaderNavigationMenu-module-scss-module__UpSVvG__mobile-nav-chevron",
  "nav": "HeaderNavigationMenu-module-scss-module__UpSVvG__nav",
  "parentCategory": "HeaderNavigationMenu-module-scss-module__UpSVvG__parentCategory",
  "spacer": "HeaderNavigationMenu-module-scss-module__UpSVvG__spacer",
});
